import React from "react"
import {Settings} from 'lucide-react'
import type { SiteSettingsTabKey } from "../siteSettingsTypes"

export function SiteSettingsShell(props: {
  children: React.ReactNode
}) {
  return <div className="p-8 bg-gray-900 min-h-screen">{props.children}</div>
}

export function SiteSettingsLoading() {
  return (
    <div className="p-8 bg-gray-900 min-h-screen">
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-400">載入中...</div>
      </div>
    </div>
  )
}

export function SiteSettingsPageTitle() {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 bg-slate-600 flex items-center justify-center">
          <Settings size={24} className="text-white" />
        </div>
        <h2 className="text-3xl font-light tracking-wider text-gray-100">網站設定</h2>
      </div>
      <p className="text-gray-400 ml-[52px]">集中管理網站功能開關，變更將即時影響前台顯示</p>
    </div>
  )
}

export function SiteSettingsTabs(props: {
  tabs: { key: SiteSettingsTabKey; label: string }[]
  activeTab: SiteSettingsTabKey
  setActiveTab: (k: SiteSettingsTabKey) => void
  onSave: () => void
  saving: boolean
  saveDisabled: boolean
}) {
  const { tabs, activeTab, setActiveTab, onSave, saving, saveDisabled } = props

  return (
    <div className="mb-6 border-b border-gray-800">
      <div className="flex items-center justify-between">
        <div className="flex gap-1">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-6 py-3 text-sm font-light tracking-wide transition-colors relative ${
                activeTab === tab.key
                  ? "text-blue-400 border-b-2 border-blue-400"
                  : "text-gray-400 hover:text-gray-200"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <button
          onClick={onSave}
          disabled={saving || saveDisabled}
          className="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white hover:bg-blue-700 disabled:bg-gray-700 disabled:cursor-not-allowed transition-colors mb-1"
        >
          <span>{saving ? "保存中..." : "保存設定"}</span>
        </button>
      </div>
    </div>
  )
}
